import { render, staticRenderFns } from "./SetRule.vue?vue&type=template&id=813c22a2&scoped=true&"
import script from "./SetRule.vue?vue&type=script&lang=js&"
export * from "./SetRule.vue?vue&type=script&lang=js&"
import style0 from "./SetRule.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SetRule.vue?vue&type=style&index=1&id=813c22a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813c22a2",
  null
  
)

export default component.exports